<template lang="jade">
  div.Form__group
    component(v-for="field in fdata.fields"
              is="type_hidden"
              ":fdata.sync"="field")
    div.Input(":tooltip"="fdata.tip"
              v-bind:class="{'Input--filled': formInput, 'Input--invalid': error, 'Input--valid': complete }"
              ":skin"="skins.inputs")
      textarea.Input__field--textarea(class="Input__field"
                                      ":disabled"="!fdata.editable"
                                      @keydown.enter="lineLimit($event)"
                                      @blur="newline($event)"
                                      v-model="formInput"
                                      ":required"="required")
      label.Input__label
        span.Input__label-content {{ fdata.label }}
</template>

<script>
  import _ from 'lodash'
  import { skins, config } from 'src/vuex/getters'
  import { addNotification, removeNotification } from 'src/vuex/actions'

  export default {
    data () {
      return {
        formInput: '',
        error: false,
        limit: this.fdata.fields.length,
        required: false,
        attempts: 0
      }
    },

    props: {
      fdata: {
        type: Object,
        coerce (val) {
          return val.editable
            ? _.set(val, 'field', false)
            : val
        }
      },
      validation: {
        type: Boolean,
        default: true
      }
    },

    vuex: {
      getters: {
        skins,
        config
      },
      actions: {
        addNotification,
        removeNotification
      }
    },

    methods: {
      newline (evt) {
        this.attempts++
        this.validate()
        this.syncData()
      },

      validate () {
        let input = _.merge(_.fill(Array(this.limit), ''),
                            _.take(this.formInput.split('\n'), this.limit))

        let fields = _.map(this.fdata.fields,
                           (x, idx) => Object.assign({}, x, {field: this.fdata.label + ` (line ${idx + 1})`}))

        let validated = _.map(input, (val, i) => {
          return this.computedValidate(fields[i], val)
        })

        this.attempts > 0 && _.some(validated, _.identity)
          ? this.setError()
          : this.setComplete()

        let errorNotice = _.partial(this.notices, 'error')

        validated.forEach((xs, i) => {
          this.dispatch(this.fdata.fields[i].field, input[i])
          errorNotice(xs, i)
        })
      },

      dispatch (prop, data) {
        if (this.fdata.editable) {
          this.$dispatch('fdata::input', {
            [prop]: data
          })
        }
      },

      notices (type, notice, suffix) {
        let idx = this.fdata.label + ` line ${suffix}`
        _.isNil(notice) || _.isEmpty(notice)
          ? this.removeNotification(idx)
          : this.addNotification({
            type: type,
            msg: notice,
            id: idx,
            show: this.config.inlineErrors ? false : _.gt(this.attempts, 0)
          })
      },

      setError () {
        this.error = true
        this.complete = false
      },

      setComplete () {
        this.error = false
        this.complete = true
      },

      lineLimit (evt) {
        let rows = this.formInput.split('\n').length
        if (rows >= this.limit) {
          evt.preventDefault()
          this.notices('info', [`This field is limited to ${this.limit} lines`])
        }
      },

      syncData () {
        let formData = this.formInput.split('\n')
        let synced = _.map(this.fdata.fields, (x, i) => {
          return !_.isNil(formData[i]) ? _.set(x, 'value', formData[i]) : x
        })
        this.$set('fdata.fields', synced)
      },

      setValue () {
        let input = this.fdata.fields.reduce((acc, field) => {
          return field.value ? acc.concat(field.value, '\n') : acc
        }, '')
        this.$set('formInput', input)
      }
    },

    // watch: {
    //   'fdata.fields': 'setValue'
    // },

    events: {
      'fdata::set': 'setValue',
      'force::validate' () {
        this.attempts = 1
        this.validate()
        return true
      }
    },

    ready () {
      // check subfields for required rule
      this.required = _.some(this.fdata.fields, xs => {
        return _.some(xs.validation, x => _.eq(x.rule, 'required'))
      })

      // concat preset values from subfields
      this.setValue()

      if (this.validation) this.validate()
    }
  }
</script>



// WEBPACK FOOTER //
// multiText.vue?55675517